/**
 * Enum que representa los tipos de documentos de pago.
 */
export enum PaymentDocumentType {
  /**
   * Factura.
   */
  INVOICE = 'invoice',
  /**
   * Boleta.
   */
  RECEIPT = 'receipt',
}
